
import { Users, Search, Sparkles, Database, Plus, UserCheck, BarChart3, Kanban, Contact, FileText, Upload } from 'lucide-react';
import { NavItem } from '../types';

const leadsItems: NavItem[] = [
  {
    title: "Lead Management",
    icon: Users,
    path: "/app/leads",
    requiredPermissions: ['lead.read'],
    children: [
      // Lead Discovery & Generation
      {
        title: "Find Leads",
        path: "/app/leads/find",
        icon: Search,
        requiredPermissions: ['lead.read', 'external_api.read'],
      },
      {
        title: "AI Lead Search",
        path: "/app/ai-lead-search",
        icon: Sparkles,
        requiredPermissions: ['lead.read', 'ai.read'],
      },
      
      // Lead Management
      {
        title: "All Leads",
        path: "/app/leads",
        icon: Database,
        requiredPermissions: ['lead.read'],
      },
      {
        title: "Add Lead",
        path: "/app/leads/add",
        icon: Plus,
        requiredPermissions: ['lead.create'],
      },
      {
        title: "Import Apollo CSV",
        path: "/app/leads/import-apollo",
        icon: Upload,
        requiredPermissions: ['lead.create'],
      },
      {
        title: "Contacts",
        path: "/app/contacts",
        icon: Contact,
        requiredPermissions: ['contact.read'],
      },
      {
        title: "Proposals",
        path: "/app/proposals",
        icon: FileText,
        requiredPermissions: ['proposal.read'],
      },
      
      // Lead Processing & Sales
      {
        title: "Lead Assignment",
        path: "/app/leads/assignment",
        icon: UserCheck,
        requiredPermissions: ['lead.update', 'user.read'],
      },
      {
        title: "Lead Analytics",
        path: "/app/leads/analytics",
        icon: BarChart3,
        requiredPermissions: ['lead.read', 'analysis.read'],
      },
      {
        title: "Sales Pipeline",
        path: "/app/leads/pipeline",
        icon: Kanban,
        requiredPermissions: ['leads_pipeline.read'],
      }
    ],
  }
];

export default leadsItems;
